import React from "react";
import { SITE, WHATSAPP_LINK } from "../lib/site-data";
import { MessageCircle, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      className="bg-[#0F172A] text-white pt-16 pb-10"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 pb-12 border-b border-white/10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3">
              <img
                src={SITE.logoUrl}
                alt="The Tutor's Table logo"
                className="h-12 w-12 rounded-full object-cover ring-1 ring-white/20"
              />
              <div>
                <div className="font-heading text-lg font-semibold">
                  The Tutor&apos;s Table
                </div>
                <div className="text-xs text-white/60">
                  Primary 3–6 · English & Math
                </div>
              </div>
            </div>
            <p className="mt-5 text-sm text-white/70 leading-relaxed max-w-sm">
              A small, focused tuition centre for Primary 3–6 students. Real
              attention. Real progress.
            </p>
          </div>

          <div>
            <div className="text-xs uppercase tracking-widest text-white/50 font-semibold mb-4">
              Get in touch
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={WHATSAPP_LINK(`Hi ${SITE.name},`)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors"
                  data-testid="footer-whatsapp"
                >
                  <MessageCircle className="w-4 h-4" />
                  WhatsApp · {SITE.whatsappNumberDisplay}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${SITE.email}`}
                  className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors break-all"
                  data-testid="footer-email"
                >
                  <Mail className="w-4 h-4" />
                  {SITE.email}
                </a>
              </li>
              <li className="flex items-start gap-2 text-white/70 leading-relaxed text-sm" data-testid="footer-address">
                <span className="inline-block mt-0.5">📍</span>
                <span>
                  {SITE.address.line1}, {SITE.address.line2}
                  <br />
                  {SITE.address.postal}
                </span>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-widest text-white/50 font-semibold mb-4">
              Quick links
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="#about"
                  className="text-white/80 hover:text-white transition-colors"
                  data-testid="footer-link-about"
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="#programmes"
                  className="text-white/80 hover:text-white transition-colors"
                  data-testid="footer-link-programmes"
                >
                  Programmes
                </a>
              </li>
              <li>
                <a
                  href="#schedule"
                  className="text-white/80 hover:text-white transition-colors"
                  data-testid="footer-link-schedule"
                >
                  Schedule
                </a>
              </li>
              <li>
                <a
                  href="#location"
                  className="text-white/80 hover:text-white transition-colors"
                  data-testid="footer-link-location"
                >
                  Visit
                </a>
              </li>
              <li>
                <a
                  href="#signup"
                  className="text-white/80 hover:text-white transition-colors"
                  data-testid="footer-link-signup"
                >
                  Sign Up
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div data-testid="footer-copyright">
            © {new Date().getFullYear()} The Tutor&apos;s Table. All rights reserved.
          </div>
          <div>Singapore · Primary 3 to 6 tuition</div>
        </div>
      </div>
    </footer>
  );
}
